import { create } from "zustand";
import { AsyncJob } from "../types/async-jobs";

interface AsyncJobState {
  asyncJobs: AsyncJob[];
  asyncJobsPagination: {
    total: number;
    limit: number;
    offset: number;
  };
}

interface AsyncJobActions {
  setAsyncJobs: (asyncJobs: AsyncJob[]) => void;
  setAsyncJobsPagination: (asyncJobsPagination: {
    total: number;
    limit: number;
    offset: number;
  }) => void;
  addAsyncJob: (asyncJob: AsyncJob) => void;

  updateAsyncJob: (id: string, updates: Partial<AsyncJob>) => void;
  removeAsyncJob: (id: string) => void;
}

const initialState: AsyncJobState = {
  asyncJobs: [],
  asyncJobsPagination: {
    total: 0,
    limit: 10,
    offset: 0,
  },
};

export const useAsyncJobStore = create<AsyncJobState & AsyncJobActions>((set) => ({
  ...initialState,

  setAsyncJobs: (asyncJobs) => set((state) => ({ ...state, asyncJobs })),

  setAsyncJobsPagination: (asyncJobsPagination) => set((state) => ({ ...state, asyncJobsPagination })),

  addAsyncJob: (asyncJob) => set((state) => ({ ...state, asyncJobs: [asyncJob, ...state.asyncJobs] })),

  updateAsyncJob: (id, updates) => set((state) => ({ ...state, asyncJobs: state.asyncJobs.map(job => job.id === id ? { ...job, ...updates } : job) })),

  removeAsyncJob: (id) => set((state) => ({ ...state, asyncJobs: state.asyncJobs.filter(job => job.id !== id) })),
}));